<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Commission Config</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Commission Config</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="overlay" v-if="is_loading">
        <img src="/assets/images/loader.svg" alt="" />
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="overlay" v-if="is_loading">
              <img src="/assets/images/loader.svg" alt="" />
            </div>
            <div class="card-header">
              <h3 class="card-title">Detail</h3>
              <div class="card-tools">
                <router-link
                  class="btn btn-info"
                  :to="{ name: 'CommissionConfigList' }"
                >
                  <i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body table-responsive p-0">
              <table class="table table-striped">
                <tbody>
                  <tr>
                    <td><b>ID</b></td>
                    <td>{{ value.id }}</td>
                  </tr>

                  <tr>
                    <td><b>Name</b></td>
                    <td>{{ value.name }}</td>
                  </tr>

                  <tr>
                    <td><b>Description</b></td>
                    <td>{{ value.description }}</td>
                  </tr>

                  <tr>
                    <td><b>Status</b></td>
                    <td>{{ value.status }}</td>
                  </tr>

                  <tr>
                    <td><b>Activation Startdate</b></td>
                    <td>{{ value.activationStart }}</td>
                  </tr>

                  <tr>
                    <td><b>Activation Enddate</b></td>
                    <td>{{ value.activationEnd }}</td>
                  </tr>

                  <tr>
                    <td><b>Priority</b></td>
                    <td>{{ value.priority }}</td>
                  </tr>

                  <tr>
                    <td><b>Commission type</b></td>
                    <td>{{ value.commissionType }}</td>
                  </tr>

                  <tr>
                    <td><b>Commission</b></td>
                    <td>{{ value.commission }}</td>
                  </tr>

                  <tr>
                    <td><b>Max commission amount</b></td>
                    <td>{{ value.maxCommissionAmount }}</td>
                  </tr>

                  <tr>
                    <td><b>Applicable Period</b></td>
                    <td>{{ value.applicablePeriod }}</td>
                  </tr>

                  <tr>
                    <td><b>Previous Tier Id</b></td>
                    <td>{{ value.prevTierId }}</td>
                  </tr>

                  <tr>
                    <td><b>Match all conditions</b></td>
                    <td>{{ value.followAllConds }}</td>
                  </tr>

                  <tr>
                    <td><b>Disbursement date configuration</b></td>
                    <td>{{ value.disbursementDateConf }}</td>
                  </tr>

                  <tr>
                    <td><b>Next disbursement date</b></td>
                    <td>{{ value.nextDisbursementDate }}</td>
                  </tr>

                  <tr>
                    <td><b>Split type</b></td>
                    <td>{{ value.splitCommission }}</td>
                  </tr>

                  <tr>
                    <td><b>App-Id</b></td>
                    <td>{{ value.appId }}</td>
                  </tr>

                  <tr>
                    <td><b>Migrate after</b></td>
                    <td>{{ value.migrateAfter }}</td>
                  </tr>

                  <tr>
                    <td><b>Commission Plan</b></td>
                    <td>{{ value.commissionPlan }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title">Commission_conditions</h3>
            </div>
            <!-- /.card-header -->
            <div class="card-body table-responsive p-0">
              <table class="table table-hover text-nowrap">
                <thead>
                  <tr></tr>
                </thead>
                <tbody>
                  <tr v-for="(val, index) in value.commission_conditions"></tr>
                </tbody>
              </table>
            </div>
            <!-- /.card-body -->
          </div>
          <!-- /.card -->
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title">Split_commissions</h3>
            </div>
            <!-- /.card-header -->
            <div class="card-body table-responsive p-0">
              <table class="table table-hover text-nowrap">
                <thead>
                  <tr></tr>
                </thead>
                <tbody>
                  <tr v-for="(val, index) in value.split_commissions"></tr>
                </tbody>
              </table>
            </div>
            <!-- /.card-body -->
          </div>
          <!-- /.card -->
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import MasterLayout from "@/components/layouts/MasterLayoutComponent.vue";
import { DepartmentsAPI } from "@/services/api";
import axios from "axios";

export default {
  name: "CommissionConfigShow",
  data: () => ({
    value: {
      commission_conditions: [],
      split_commissions: [],
    },
    pre: {},
    is_loading: false,
  }),
  mounted: function () {
    this.initialize();
  },
  methods: {
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      await this.getDetail(this.params.id).then((detail) => {
        this.value = detail;
      });

      this.is_loading = false;
    },
    getDetail: function (id) {
      let _this = this;
      return new Promise((resolve) => {
        let api_url = "/commission_configs/" + id;
        _this.is_loading = true;
        axios
          .get(api_url)
          .then((response) => {
            _this.value = response.data;
            resolve(response.data);
          })
          .catch((error) => {
            console.log("error " + error);
            resolve(error);
          })
          .finally(() => {
            _this.is_loading = false;
          });
      });
    },
  },
  created() {
    this.$emit("update:layout", MasterLayout);
  },
};
</script>
